import React, { useState, useCallback } from 'react';
import { Modal, Divider, Space } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';
import BaselineForecastForm from './BaselineForecastForm';
import BaselineForecastTable from './BaselineForecastTable';

interface BaselineForecastModalProps {
  visible: boolean;
  onCancel: () => void;
}

const BaselineForecastModal: React.FC<BaselineForecastModalProps> = ({
  visible,
  onCancel,
}) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefresh = useCallback(() => {
    setRefreshKey(prev => prev + 1);
  }, []);

  const handleFormSuccess = useCallback(() => {
    handleRefresh();
  }, [handleRefresh]);

  return (
    <Modal
      title={
        <Space>
          <BarChartOutlined />
          <span>Baseline Forecast Management</span>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      width={1200}
      footer={null}
      destroyOnClose
    >
      <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        <BaselineForecastForm onSuccess={handleFormSuccess} />
        
        <Divider />
        
        <BaselineForecastTable key={refreshKey} onRefresh={handleRefresh} />
      </div>
    </Modal>
  );
};

export { BaselineForecastModal };